import {action, computed, observable} from "mobx";
import Campaign from "./Campaign";
import CampaignInterface from "./CampaignInterface";
import TemplateStore from "./TemplateStore";
import UiStore from "./UiStore";
import {WpexApi} from "../api/WpexApi";

export default class CampaignStore {

    api: WpexApi;

    @observable loadingData: boolean = false;

    @observable loading: boolean = false;

    @observable campaigns: Campaign[] = [];

    @observable campaign: Campaign;

    @observable templateStore: TemplateStore;

    @observable mailchimpLists: any = [];

    constructor(templateStore: TemplateStore, uiStore: UiStore, api: WpexApi) {
        this.templateStore = templateStore;
        this.campaign = new Campaign(this, templateStore);
        this.api = api;
        this.loadInitData(this.campaign);
    }

    loadInitData = async (campaign: Campaign) => {
        this.loadingData = true;
        const lists = this.api.getMailchimpLists();
        let campaignAsync = this.api.getCampaignByPostId(campaign.post_id);

        this.setMailchimpLists(await lists);
        this.campaign.updateFromJson(await campaignAsync);
        this.loadingData = false;
    }

    @action setMailchimpLists(lists: [] | null) {
        if (lists) {
            this.mailchimpLists = lists.map((list: any) => ({id: list.id, displayName: list.name}));
        }
    }

    @computed get isWidgetSelected(): boolean {
        return (this.campaign.template && this.campaign.template.isWidgetSelected) ? this.campaign.template.isWidgetSelected : false;
    }

    @computed get widgetSelectedIndex(): number | null {
        return (this.campaign.template && this.campaign.template.widgetSelectedIndex) ? this.campaign.template.widgetSelectedIndex : null;
    }

    updateTodoFromServer(json: CampaignInterface): Campaign {
        let campaign = this.campaigns.find(campaign => campaign.id === json.id);
        if (!campaign) {
            campaign = new Campaign(this, this.templateStore);
            this.campaigns.push(campaign);
        }
        campaign.updateFromJson(json);
        return campaign;
    }

    async save() {
        this.loading = true;
        const response = await this.api.saveCampaign(this.campaign);
        await new Promise((rs, rj) => {
            setTimeout(() => rs(), 2000);
        });
        this.loading = false;
        return response;
    }

    async loadAll(): Promise<Campaign[]> {

        let campaigns: Campaign[] = [];

        try {
            const data = await this.api.loadCampaigns();
            campaigns = data.map((campaign: CampaignInterface): Campaign => this.updateTodoFromServer(campaign));
        } catch (e) {

        }
        return campaigns;
    }

    select(id: number) {

        let campaign: Campaign | undefined = this.campaigns.find(campaign => campaign.id === id);

        if (campaign) {
            this.campaign = campaign;
        }
    }

    getPostIdFromUrl(): number {
        const url = new URL(window.location.href);
        return Number(url.searchParams.get("post"));
    }

    setWidgetSelected(widgetIndex: number | null = null) {
        this.campaign.setWidgetSelected(widgetIndex);
    }

}
